import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './SystemLayout.css';

const NAV_ITEMS = [
  { to: '/system/dashboard', icon: '📊', label: 'डॅशबोर्ड' },
  { to: '/system/tenants',   icon: '🏘️', label: 'ग्रामपंचायती' },
  { to: '/system/users',     icon: '👥', label: 'प्रणाली वापरकर्ते' },
  { to: '/system/roles',     icon: '🔐', label: 'भूमिका व परवानग्या' },
  { to: '/system/legacy-tax-migration', icon: '🗃️', label: 'जुना कर डेटा स्थलांतर' },
];

export default function SystemLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/system/login');
  };

  return (
    <div className="system-layout">
      {/* Sidebar */}
      <aside className={`system-sidebar${sidebarOpen ? ' open' : ''}`}>
        <div className="system-sidebar-header">
          <span className="system-sidebar-logo">⚙️</span>
          <div>
            <h2>प्रणाली प्रशासक</h2>
            <p>व्यासपीठ व्यवस्थापन</p>
          </div>
        </div>

        <nav className="system-nav">
          {NAV_ITEMS.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `system-nav-link${isActive ? ' active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <span>{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="system-sidebar-footer">
          <span style={{ fontSize: '0.75rem', opacity: 0.65 }}>डिजिटल ग्रामपंचायत पोर्टल</span>
        </div>
      </aside>

      {/* Overlay */}
      {sidebarOpen && <div className="system-overlay" onClick={() => setSidebarOpen(false)} />}

      {/* Main */}
      <div className="system-main">
        <header className="system-header">
          <div className="system-header-left">
            <button className="system-hamburger" onClick={() => setSidebarOpen(o => !o)} aria-label="Toggle menu">☰</button>
            <div>
              <div className="system-header-title">प्रणाली प्रशासन</div>
              <div className="system-header-sub">सर्व ग्रामपंचायत व वापरकर्ते व्यवस्थापित करा</div>
            </div>
          </div>
          <div className="system-header-right">
            <div className="system-user-badge">
              <strong>{user?.name || user?.email}</strong>
              <em>सुपर प्रशासक</em>
            </div>
            <button className="system-logout-btn" onClick={handleLogout}>बाहेर पडा</button>
          </div>
        </header>

        <main className="system-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
